import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import {
    contactPersonsSelector,
    dashboardActions,
} from '../../../../../../store/slices/dashboardSlice/dashboardSlice';

export const useManagerCardList = () => {
    const dispatch = useDispatch();

    //@ts-ignore
    const { is_customer, can_show_financial_info } = useSelector((state) => state.dashboardReducer);
    const contactPerson = useSelector(contactPersonsSelector.selectAll);

    const onShowManagerInfo = useCallback(() => {
        dispatch(dashboardActions.onModalMode('showManagerInfo'));
    }, [contactPerson]);

    const onAddManager = useCallback(() => {
        dispatch(dashboardActions.onModalMode('addManager'));
    }, [contactPerson]);

    return { onShowManagerInfo, onAddManager, contactPerson, is_customer, can_show_financial_info };
};
